import { AutogenModelCarrierCommitmentHistory, AutogenRowCarrierCommitmentHistory } from "./autogen/AutogenModelCarrierCommitmentHistory";

export class ModelCarrierCommitmentHistory extends AutogenModelCarrierCommitmentHistory<RowCarrierCommitmentHistory> {
	constructor() {
		super(RowCarrierCommitmentHistory);
	}
}

export class RowCarrierCommitmentHistory extends AutogenRowCarrierCommitmentHistory {
}